import {
    IClipboardDetails, IClipboardFindOptions, IClipboardItem,
    IClipboardService,
    IFrameworkUsageService,
    IUsageDetails,
    IUsageOptions,
    IUsageResponse
} from "./PA.UIFramework.IF.Services";
import {WB_UIUsageRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_UI_Usage} from "../PA.Core/PAdbSchema";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {DateUtils} from "../PA.Core/Basic/Dates";
import * as _ from "lodash"
import axios from "axios";
import {ISessionContext} from "../PA.Core/PA.Core.IF.Session";
import {JSONUtils} from "../PA.Core/Basic/JSON";


export interface IFrameworkServiceRequest {
    requestType: string,
    usageOptions?: IUsageOptions
}

export interface IFrameworkServiceResponse {
    request: IFrameworkServiceRequest,
    bError: boolean,
    sErrors: string[],
    results: any
}


export class UIFrameworkService
    implements IFrameworkUsageService {
    private _records: IUsageDetails[] = []

    constructor() {
        this._records = []
    }

    ResetUsage(): void {
        this._records = []
    }


    LogUsageSync(usageRecord: IUsageDetails | IUsageDetails[]): void {
        const self = this

        if (!_.isArray(usageRecord)) {
            usageRecord = [usageRecord]
        }

        _.forEach(usageRecord, (aRecord: IUsageDetails) => {
            if ('Usage' in aRecord) {
                self._records.push(aRecord)
            }
        })
    }


    async SaveUsage(): Promise<void> {
        const self = this

        let dbContext = new PAdbContext()
        let wbSessionId: number = 0
        let wbUserId: number = 0
        let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        let sessContext: ISessionContext = PAEnvironment.getValue(PAEnvironment.SessionContext)
        if (!_.isEmpty(usrContext))
            wbUserId = usrContext?.User?.cif?.WB_AUTHUSR_ID

        if (!_.isEmpty(sessContext))
            wbSessionId = sessContext?.Session?.cif?.WB_SESSION_ID

        let aTS = DateUtils.convertToSAPBWTs(DateUtils.today)

        let writeRows: WB_UIUsageRow[] = []

        for (let aDtl of self._records) {

            let aRecord = <WB_UIUsageRow>await dbContext.createRecordWithKey(esWB_UI_Usage)
            aRecord.cif.WB_SESSION_ID = wbSessionId
            aRecord.cif.WB_AUTHUSR_ID = wbUserId
            aRecord.cif.USAGE = aDtl.Usage || 'NA'
            aRecord.cif.ERROR_IND = aDtl.ErrorInd ? '1' : '0'
            aRecord.cif.ERROR_DTTS = aDtl.ErrorInd ? aTS : 0
            aRecord.cif.START_DTTS = DateUtils.convertToSAPBWTs(aDtl.StartDtTs) || 0
            aRecord.cif.END_DTTS = DateUtils.convertToSAPBWTs(aDtl.EndDtTs) || 0
            aRecord.cif.WB_UI_APP_ID = aDtl.wbUIAppId || 0
            aRecord.cif.WB_UI_APPMODULE_ID = aDtl.wbUIAppModuleId || 0
            aRecord.cif.BO_WB_ID = aDtl.BO_wb_id || 0
            aRecord.cif.BO_UI_ID = aDtl.BO_ui_id || ''
            aRecord.cif.BO_NAME = aDtl.BO_name || ''
            writeRows.push(aRecord)


        }

        await dbContext.Save(esWB_UI_Usage, writeRows)

        self.ResetUsage()

    }


    async getUsage(usageOptions: IUsageOptions): Promise<IUsageResponse> {
        return UIFrameworkService.makeRequest("getUsage", usageOptions)
    }


    private static makeRequest(requestType: string,
                               usageOptions: IUsageOptions,
                               options?: any): Promise<any> {
        return new Promise<any[]>((resolve, error) => {


            let frameworkRequest: IFrameworkServiceRequest = {
                requestType: requestType

            }

            if (usageOptions)
                frameworkRequest.usageOptions = usageOptions

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'uiframework';
            else
                sEndPoint += '/uiframework';

            axios.post(sEndPoint, {data: {request: frameworkRequest}})
                .then((resp: any) => {
                    let responseData: IFrameworkServiceResponse = resp.data;
                    if ('request' in responseData) {
                        if (responseData.bError) {
                            error("UI Framework Service Response: " + (responseData.sErrors || ['Unknown']).toString())
                        } else {
                            resolve(responseData.results)
                        }
                    } else {
                        error('Unable to parse UI Framework Service Web Response: ' + responseData);
                    }
                })
                .catch((err: any) => {
                    error('Unable to obtain UI Framework Service Results from Server. ' + err);
                });
        });
    }


}


export interface IClipboardRequest {
    requestType: string,
    clipboardOptions?: IClipboardFindOptions,
    clipboardDetails?: IClipboardDetails[]
}

export interface IClipboardResponse {
    request: IClipboardRequest,
    bError: boolean,
    sErrors: string[],
    results: any
}

export class UIClipboardService
    implements IClipboardService {

    // This should implement a local cache, so it doesn't reach to the server all the time. local static dictionary by usage/sububage..[]

    constructor() {
    }


    async SaveClipboardEntry(options: IClipboardDetails): Promise<void> {

        let dbContext = new PAdbContext()
        let wbUserId: number
        let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (!_.isEmpty(usrContext)) {
            wbUserId = usrContext?.User?.cif?.WB_AUTHUSR_ID
        }
        let bCreate = false


        if ('Usage' in options && options.Usage == "Snapshot") {
            let clipboard = <WB_UIUsageRow[]>await dbContext.findAll(esWB_UI_Usage, {
                where: {
                    WB_AUTHUSR_ID: wbUserId,
                    USAGE: options.Usage,
                    SUBUSAGE: options.SubUsage
                }
            })
            if (!_.isEmpty(clipboard)) {
                if (JSON.stringify(clipboard[0].cif.CLIP) != JSON.stringify(options.Clip)) {
                    clipboard[0].cif.CLIP = JSON.stringify(options.Clip)
                    dbContext.Save(esWB_UI_Usage, clipboard[0])
                }

            } else {
                bCreate = true
            }
        } else {
            bCreate = true
        }
        if (bCreate) {
            let opts: IClipboardFindOptions = {
                usage: options.Usage,
                subUsage: options.SubUsage,
                wbUserId: wbUserId,
                details: {
                    Usage: options.Usage,
                    SubUsage: options.SubUsage,
                    Clip: options.Clip,
                    LastDate: undefined
                }
            }
            await UIClipboardService.makeRequest("SaveClipboardEntry", opts)
        }

    }


    async FindClipboardEntry(opts: IClipboardFindOptions): Promise<IClipboardItem[]> {
        let r: IClipboardItem[] = await UIClipboardService.makeRequest("FindClipboardEntry", opts)
        _.forEach(r, item => {
            if (_.isString(item.LastDate))
                item.LastDate = new Date(item.LastDate)
            if (_.isString(item.Clip))
                item.Clip = JSONUtils.parse(item.Clip, item.Clip)
        })

        return r
    }


    private static async makeRequest(requestType: string,
                                     clipboardOpts: IClipboardFindOptions,
                                     options?: any): Promise<any> {

        let clipboardRequest: IClipboardRequest = {
            requestType: requestType,
            clipboardOptions: clipboardOpts
        }

        let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
        if (sEndPoint.endsWith('/'))
            sEndPoint += 'clipboard';
        else
            sEndPoint += '/clipboard';

        let resp = await axios.post(sEndPoint, {data: {request: clipboardRequest}})
        let responseData: IClipboardResponse = resp.data;
        if ('request' in responseData) {
            if (responseData.bError) {
                throw new Error("UI Clipboard Service Response: " + (responseData.sErrors || ['Unknown']).toString())
            } else {
                return responseData.results
            }
        } else {
            throw new Error('Unable to parse UI Clipboard Service Web Response: ' + responseData);
        }
    }

}